import { LogOut } from 'lucide-react'

interface MenuUserInfoProps {
  user: { email?: string; username?: string } | null
  onLogout: () => void
  compact?: boolean
}

export default function MenuUserInfo({ user, onLogout, compact }: MenuUserInfoProps) {
  if (compact) {
    return (
      <div className="flex items-center gap-2">
        <div className="w-8 h-8 rounded-full flex items-center justify-center"
          style={{ backgroundColor: 'var(--primary-600)' }}>
          <span className="text-sm font-medium text-white">
            {user?.email?.charAt(0).toUpperCase()}
          </span>
        </div>
        <button
          onClick={onLogout}
          className="p-1.5 rounded-lg transition-colors"
          style={{ color: 'var(--text-muted)' }}
          title="Logout"
        >
          <LogOut className="w-4 h-4" />
        </button>
      </div>
    )
  }

  return (
    <div className="flex items-center gap-3">
      <div className="w-10 h-10 rounded-full flex items-center justify-center"
        style={{ backgroundColor: 'var(--primary-600)' }}>
        <span className="font-medium text-white">
          {user?.email?.charAt(0).toUpperCase()}
        </span>
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium truncate" style={{ color: 'var(--text-on-sidebar)' }}>
          {user?.username}
        </p>
        <p className="text-xs truncate" style={{ color: 'var(--text-muted)' }}>
          {user?.email}
        </p>
      </div>
      <button
        onClick={onLogout}
        className="p-2 transition-colors hover:text-red-400"
        style={{ color: 'var(--text-muted)' }}
        title="Logout"
      >
        <LogOut className="w-5 h-5" />
      </button>
    </div>
  )
}
